import { styled } from '@mui/material';
import { Button, vars } from '@tgtg/kit';
import { FormattedMessage } from 'react-intl';

import { type CharityVettingNavigationItem } from '../../../utils/navigationTypes';

import LanguageSelect from './LanguageSelect';
import { MenuItem } from './MenuItem';
import msg from './messages';
import { StyledMenuContent, StyledMenuFooter } from './StyledComponents';

const StyledButton = styled(Button)(({ theme: { palette } }) => ({
  color: vars.color.content.inverse,
  textDecoration: 'underline',
  '&:focus-visible': {
    boxShadow: 'none',
    outline: `2px solid ${palette.cvi.primary[20]}`,
  },
}));

interface MenuContentProps {
  menuItems: CharityVettingNavigationItem[];
  onToggleDialog: VoidFunction;
  onClick: (item: CharityVettingNavigationItem) => void;
  onFocusNavigation: (direction: 'up' | 'down') => void;
  onStepsProgress: (item: CharityVettingNavigationItem) => boolean;
}

const MenuContent = ({
  menuItems,
  onToggleDialog,
  onClick,
  onFocusNavigation,
  onStepsProgress,
}: MenuContentProps) => {
  const handleOnClick = (item: CharityVettingNavigationItem) => onClick(item);
  const handleFocusNavigation = (direction: 'up' | 'down') => onFocusNavigation(direction);
  const handleStepsProgress = (item: CharityVettingNavigationItem) => onStepsProgress(item);
  return (
    <>
      <StyledMenuContent>
        {menuItems.map((item, index) => (
          <MenuItem
            key={item.id}
            item={item}
            stepNumber={index + 1}
            onClick={handleOnClick}
            onFocusNavigation={handleFocusNavigation}
            isClickable={handleStepsProgress(item)}
          />
        ))}
      </StyledMenuContent>
      <StyledMenuFooter>
        <LanguageSelect />
        <StyledButton onClick={onToggleDialog} variant='transparent'>
          <FormattedMessage {...msg.charityVettingContactUs} />
        </StyledButton>
      </StyledMenuFooter>
    </>
  );
};

export default MenuContent;
